import i18next from 'i18next'

export const DEFAULT_THANK_YOU_SCREEN_TITLE = 'Thank you for filling out our questionnaire!'
export const DEFAULT_THANK_YOU_SCREEN_DESCRIPTION = JSON.stringify([
	{
		type: 'paragraph',
		props: { textAlignment: 'center' },
		content: [{ type: 'text', text: 'Your response has been saved.', styles: {} }],
	},
])

function formatDescription(text: string): string {
	return JSON.stringify([
		{
			type: 'paragraph',
			props: { textAlignment: 'center' },
			content: [{ type: 'text', text, styles: {} }],
		},
	])
}

export type ThankYouScreenLogo = {
	id: string
	url: string
}

export type ThankYouScreen = {
	id: string
	title: string
	description: string
	min_score_range: number
	max_score_range: number
	organisation_name?: string | null
	logo?: ThankYouScreenLogo | null
}

export type ThankYouScreenScoreCategory = 'excellent' | 'good' | 'noMatch'

export function getScoreCategory(minScore: number): ThankYouScreenScoreCategory {
	if (minScore >= 89) { return 'excellent' }
	if (minScore >= 66) { return 'good' }
	return 'noMatch'
}

export function getScoreCategoryLabel(category: ThankYouScreenScoreCategory): string {
	switch (category) {
		case 'excellent':
			return i18next.t('editor:thankYouScreen.scoreCategories.excellent')
		case 'good':
			return i18next.t('editor:thankYouScreen.scoreCategories.good')
		case 'noMatch':
			return i18next.t('editor:thankYouScreen.scoreCategories.noMatch')
	}
}
